/*
 * No.9 Caffè — Blog listing (sections/main-blog-no9.liquid)
 *
 * Two jobs:
 *   1. Whole-card click → the article.
 *   2. Share a fixed line budget between each card's title and preview.
 *
 * On (2): the CSS already produces equal-height cards on its own — titles
 * reserve their full allowance and previews take the rest. This script only
 * makes it prettier, by measuring how many lines a title REALLY occupies and
 * handing any line it did not need to the preview. A one-line title therefore
 * buys a three-line preview instead of leaving a gap. The total never moves,
 * so the cards stay level either way. If this file fails to load, the page is
 * still correct.
 */
(function () {
  'use strict';

  var GRID = '.bn9__grid';

  /* ---- Whole-card click → article ----
     Delegated so it survives theme-editor section re-renders. Guards: any
     real link or control inside the card handles its own click; a drag and a
     text selection must never navigate. */
  var downX = 0;
  var downY = 0;
  var dragged = false;

  document.addEventListener(
    'pointerdown',
    function (e) {
      downX = e.clientX;
      downY = e.clientY;
      dragged = false;
    },
    { passive: true }
  );

  document.addEventListener(
    'pointermove',
    function (e) {
      if (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8) dragged = true;
    },
    { passive: true }
  );

  document.addEventListener('click', function (e) {
    var card = e.target.closest('.bn9__card[data-card-href]');
    if (!card) return;
    if (dragged) return;
    if (e.target.closest('a, button, input, select, textarea, label, [role="button"]')) return;
    if (window.getSelection && String(window.getSelection())) return;
    var href = card.getAttribute('data-card-href');
    if (href) window.location.href = href;
  });

  /* ---- Line budget ---- */

  // Computed line-height comes back in px in every current browser, but it
  // can still be the keyword "normal" if something upstream unsets it.
  function lineHeightOf(el) {
    var cs = getComputedStyle(el);
    var lh = parseFloat(cs.lineHeight);
    if (lh > 0) return lh;
    return parseFloat(cs.fontSize) * 1.3;
  }

  function balance(grid) {
    var cards = grid.querySelectorAll('.bn9__card');
    if (!cards.length) return;

    var budget = parseInt(grid.getAttribute('data-line-budget'), 10) || 4;
    var titleMax = parseInt(grid.getAttribute('data-title-max'), 10) || 2;

    // Liquid already clamps this, but the invariant is what makes the cards
    // equal, so it is enforced on both sides rather than trusted across the
    // boundary. The preview must always be owed at least one line.
    titleMax = Math.max(1, Math.min(titleMax, budget - 1));

    // Phase 1 — READ. One class toggle for the whole grid, then measure every
    // title, so the browser does a single style recalculation instead of one
    // per card. Interleaving reads and writes here would thrash layout.
    grid.classList.add('bn9__grid--measuring');

    var lines = [];
    for (var i = 0; i < cards.length; i++) {
      var title = cards[i].querySelector('.bn9__title');
      if (!title) {
        lines.push(0);
        continue;
      }
      var h = title.getBoundingClientRect().height;
      lines.push(Math.max(1, Math.round(h / lineHeightOf(title))));
    }

    grid.classList.remove('bn9__grid--measuring');

    // Phase 2 — WRITE. The title keeps its real line count, capped at the
    // maximum; whatever is left of the budget goes to the preview.
    for (var j = 0; j < cards.length; j++) {
      if (!lines[j]) continue;
      var used = Math.min(lines[j], titleMax);
      var left = budget - used; // >= 1 by the clamp above
      cards[j].style.setProperty('--bn9-title-lines', String(used));
      cards[j].style.setProperty('--bn9-excerpt-lines', String(left));
    }
  }

  function balanceAll() {
    var grids = document.querySelectorAll(GRID);
    for (var i = 0; i < grids.length; i++) balance(grids[i]);
  }

  var resizeTimer = null;
  function onResize() {
    // A narrower column can turn a one-line title into two, which changes
    // what the preview is owed.
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(balanceAll, 150);
  }

  function init() {
    balanceAll();

    // N27 loads asynchronously. Until it swaps in, titles are measured in the
    // fallback face and can wrap differently, so measure again once the real
    // font is in.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(balanceAll).catch(function () {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', onResize, { passive: true });

  // Theme editor: re-run when the section is re-rendered or reloaded.
  document.addEventListener('shopify:section:load', balanceAll);
  document.addEventListener('shopify:section:reorder', balanceAll);
})();
